import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FhirLoader from '../../../../FhirLoader'
import { GoalBundle } from '../../../../../types/FHIRTypes/Bundle'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { Goal as FHIRGoal } from '@teschglobal/tg-fhir-react-components/dist/types'
import { Goal } from '@teschglobal/tg-fhir-react-components'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'

type GoalDetailProps = {
    goalDetailId: string | undefined;
}

const GoalDetail: FC<GoalDetailProps> = ({ goalDetailId }) => {
  const { patientAccessFhirConfig } = useFhirConfig()
  const {
    data: goal,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRGoal, Error> =
    useFhirResourceById('Patient Access', goalDetailId || '', 'Goal')
  
  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!goal || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }

  return (
    <div>
      <section>
        <Goal
          data={goal}
          fhirApiConfig={patientAccessFhirConfig}
        />
      </section>
    </div>
  )
}

export default GoalDetail